export const CHART_AXES_LABEL_TYPE = {
  VALUE: 'Values',
  LINE: 'Line Only',
};
export const CHART_GUIDE_FREQUENCY = {
  TICKS: 'Ticks',
  SPARSE: 'Sparse',
};
const TICK_LENGTH = 4;
export const CHART_LAYOUT = {
  AXES: {
    /* How much space each axis zone should take up */
    AREA: { top: 0, right: 50, bottom: 50, left: 50 },
    /* Whether to draw the labels on the axis */
    LABELS: {
      top: null,
      right: null,
      bottom: CHART_AXES_LABEL_TYPE.VALUE,
      left: CHART_AXES_LABEL_TYPE.VALUE,
    },
    /* 
    Whether to have space between the axis(line) and the canvas
        area that the data is drawn on
     */
    PADDING: { top: 8, right: 8, bottom: 8, left: 8 },
    /* Draw axis lines into the corners or fit to the canvas size */
    CONSTRAIN_LINES_TO_PADDING: true,
    /* When an axis is drawn (has a label value), how long are the marks */
    TICKS: {
      top: TICK_LENGTH,
      right: TICK_LENGTH,
      bottom: TICK_LENGTH,
      left: TICK_LENGTH,
    },
    /* Outside ticks can be sized differently if needed */
    TICKS_OUTER: {
      top: TICK_LENGTH,
      right: TICK_LENGTH,
      bottom: TICK_LENGTH,
      left: TICK_LENGTH,
    },
    /* If the canvas area should have guidelines */
    GUIDES: {
      // TODO (future): allow values array as well as modal version
      VERTICAL: CHART_GUIDE_FREQUENCY.SPARSE,
      HORIZONTAL: CHART_GUIDE_FREQUENCY.SPARSE,
    },
  },
  /* 
  The size of the area containing the rendered data 
  TODO (future): options for expanding proportionally
  */
  CANVAS: {
    WIDTH: 1000,
    HEIGHT: 500,
  },
};

/* 
This structure defines classes for the zones/regions universal to 
basic chart types
*/
export const CHART_LAYOUT_CLASSES = {
  DEFS: 'scatter-defs',
  BACKGROUND: 'scatter-background',
  IN_MARGINS: 'scatter-in-margins',
  AXIS_TOP: 'scatter-top-axis',
  AXIS_RIGHT: 'scatter-right-axis',
  AXIS_BOTTOM: 'scatter-bottom-axis',
  AXIS_LEFT: 'scatter-left-axis',
  AXIS_TOP_INNER: 'scatter-top-axis-inner',
  AXIS_RIGHT_INNER: 'scatter-right-axis-inner',
  AXIS_BOTTOM_INNER: 'scatter-bottom-axis-inner',
  AXIS_LEFT_INNER: 'scatter-left-axis-inner',
  AXIS_TOP_EXTENDED_BAR: 'scatter-top-axis-extended-bar',
  AXIS_RIGHT_EXTENDED_BAR: 'scatter-right-axis-extended-bar',
  AXIS_BOTTOM_EXTENDED_BAR: 'scatter-bottom-axis-extended-bar',
  AXIS_LEFT_EXTENDED_BAR: 'scatter-left-axis-extended-bar',
  IN_AXES: 'scatter-in-axis',
  GUIDES_HORIZONTAL: 'scatter-guides-hor',
  GUIDES_VERTICAL: 'scatter-guides-ver',
  CANVAS: 'scatter-canvas',
};

/* 
Types of scaling function determination
*/
export const CHART_SCALE_TYPE = {
  /* Categorical values for points/bubbles/bars (set of discreet values) */
  CATEGORICAL: 'Categorical',
  /* Normal linear scaling */
  NUMERIC: 'Numeric',
  /* Sqrt scale used for defining radius (so value ∝ area) */
  NUMERIC_RADIUS: 'Radius',
};

/* 
Describes the type of object being output by the scale selection 
In most cases "point" is the choice (essentially, any linear outcome)
  Bar is for making bars: it allows auto-offset for the half width, and auto-padding
*/
export const CHART_SCALE_DISPLAY_TYPE = {
  POINT: 'Point',
  BAR: 'Bar',
};

/* Object with all the attributes of axis setup in default manner */
export const DEFAULT_AXIS_SETUP = {
  /* Type changes scale generation */
  TYPE: CHART_SCALE_TYPE.NUMERIC,
  /* Domain can be overridden, but normally is auto-generated from data */
  DOMAIN: null,
  /* 
  Range Can be overridden, else domain is auto-generated from available size
    usually canvas or radius defaults
  */
  RANGE: null,
  /* Padding or paddingOuter (scale band) ~ applied for categorical axis */
  PADDING: null,
  /* 
  PaddingInner is specific to scaleBand ~ proportion of each bar that should be trimmed
    for space between bars. Defaults to 5%
  */
  PADDING_INNER: null,
  /* 
  Nice axes auto extend out from a specified domain to find the nearest rounded scale 
    Turn this off for bespoke sizing (normally radius of a shape)
  */
  NICE: true,
  /* 
  Invert controls whether range should be [min...max] or vice versa. 
    Because SVG y=0 is higher than y=1, when plotting a chart with a y-axis that has lower numbers
    at the bottom (i.e. normal vertical bar chart), invert is used to correct the direction
  */
  INVERT: false,
  /* Ticks allows a number of ticks to be specified if required */
  TICKS: null,
};
